"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8932],{

/***/ 28932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ HeroBanner_HeroBanner7; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
;// CONCATENATED MODULE: ./src/components/DesignSystem/HeroBanner/common/HeroBannerWrapperComponent.styles..js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: flex;\n  margin-bottom: 72px;\n  @media screen and (max-width: 766px) {\n    margin-bottom: 64px;\n    &.herobanner6 {\n      margin-bottom: 0;\n    }\n  }\n\n  ",
        "\n\n  .arrow-btns {\n    top: 50%;\n    transform: translateY(-50%);\n    z-index: 1;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var HeroBannerWrapperComponent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "HeroBannerWrapperComponent",
    componentId: "sc-a1debd79-0"
})(_templateObject(), function(props) {
    return props.additionalStyles;
});

;// CONCATENATED MODULE: ./src/components/DesignSystem/HeroBanner/HeroBanner7/HeroBanner7.styles.js

function HeroBanner7_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (min-width: 767px) {\n    ",
        "\n  }\n\n  @media screen and (max-width: 766px) {\n    ",
        "\n  }\n"
    ]);
    HeroBanner7_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  flex: 1;\n  position: relative;\n\n  @media screen and (min-width: 767px) {\n    ",
        "\n  }\n\n  @media screen and (max-width: 766px) {\n    ",
        "\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  object-fit: cover;\n  height: 100%;\n  position: relative;\n\n  & > .next-banner-image {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: center center;\n  }\n\n  @media screen and (min-width: 767px) {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n\n    & > .next-banner-image {\n      filter: ",
        ";\n      object-fit: cover;\n    }\n  }\n\n  @media screen and (max-width: 766px) {\n    height: 100%;\n\n    & > .next-image {\n      object-position: center top;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex: 1;\n\n  @media screen and (min-width: 767px) {\n    position: absolute;\n    z-index: 5;\n    height: 100%;\n    width: 100%;\n  }\n\n  @media screen and (max-width: 766px) {\n    height: 25%;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  @media screen and (min-width: 767px) {\n    max-width: 500px;\n    text-align: center;\n  }\n\n  @media screen and (max-width: 766px) {\n    display: flex;\n    flex-direction: column-reverse;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 0 0 auto;\n  height: fit-content;\n  width: 100%;\n  align-items: center;\n  flex-direction: column;\n\n  @media screen and (max-width: 766px) {\n    padding: 1rem 0;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: ",
        ";\n  overflow: hidden;\n  object-fit: cover;\n  margin: 0 auto;\n  position: relative;\n\n  & > .next-store-image {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: center center;\n  }\n\n  @media screen and (min-width: 767px) {\n    height: 77px;\n    width: 77px;\n  }\n\n  @media screen and (max-width: 766px) {\n    height: 57px;\n    width: 57px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  @media screen and (min-width: 767px) {\n    color: #ffffff;\n    font-size: 56px;\n    margin-bottom: 30px;\n  }\n\n  @media screen and (max-width: 766px) {\n    color: ",
        ";\n    font-size: 20px;\n    margin-bottom: 0;\n    text-align: center;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n\n  @media screen and (min-width: 767px) {\n    font-size: 16px;\n    color: #ffffff;\n    display: block;\n    width: 100%;\n    max-width: 350px;\n    margin: 0 auto 20px;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    -webkit-line-clamp: 4;\n    -webkit-touch-callout: text;\n    -webkit-user-select: text;\n    -khtml-user-select: text;\n    -moz-user-select: text;\n    -ms-user-select: text;\n    user-select: text;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n\n  @media screen and (max-width: 766px) {\n    display: none;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n\n  @media screen and (min-width: 767px) {\n    flex-direction: row;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}


var getBannerHeight = function(props, deviceType) {
    var headerHeight = props.heightCalculation || (deviceType === "mobile" ? 80 : 90);
    if (props.bannerFixedRatio === 0) {
        // fixed height
        if (deviceType === "mobile") {
            return "height: calc(100vh - ".concat(headerHeight, "px)");
        } else {
            return "height: calc(100vh - ".concat(headerHeight, "px)");
        }
    } else {
        // fixed aspect ratio
        if (deviceType === "mobile") {
            return "height: 0; padding-top: ".concat(16 / 9 * 100, "%;");
        } else {
            return "height: 0; padding-top: ".concat(9 / 16 * 100, "%;");
        }
    }
};
var HeroBannerWrapperComponent7 = (0,styled_components_browser_esm/* default */.ZP)(HeroBannerWrapperComponent).withConfig({
    displayName: "HeroBannerWrapperComponent7",
    componentId: "sc-e949be28-0"
})(HeroBanner7_styles_templateObject(), function(props) {
    return getBannerHeight(props, "desktop");
}, function(props) {
    return getBannerHeight(props, "mobile");
});
var HeroBannerComponent = styled_components_browser_esm/* default.main.withConfig */.ZP.main.withConfig({
    displayName: "HeroBannerComponent",
    componentId: "sc-e949be28-1"
})(_templateObject1(), function(props) {
    return getBannerHeight(props, "desktop");
}, function(props) {
    return getBannerHeight(props, "mobile");
});
var HeroBannerImage = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "HeroBannerImage",
    componentId: "sc-e949be28-2"
})(_templateObject2(), function(param) {
    var imageBrightness = param.imageBrightness;
    return imageBrightness ? "brightness(1)" : "brightness(0.7)";
});
var HeroBannerInteractivePosition = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "HeroBannerInteractivePosition",
    componentId: "sc-e949be28-3"
})(_templateObject3());
var HeroBannerInteractiveBody = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "HeroBannerInteractiveBody",
    componentId: "sc-e949be28-4"
})(_templateObject4());
var HeroBannerSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "HeroBannerSection",
    componentId: "sc-e949be28-5"
})(_templateObject5());
var HeroBannerStoreImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "HeroBannerStoreImage",
    componentId: "sc-e949be28-6"
})(_templateObject6(), function(props) {
    return props.roundness;
});
var HeroBannerHeading = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    displayName: "HeroBannerHeading",
    componentId: "sc-e949be28-7"
})(_templateObject7(), function(props) {
    return props.primaryColor;
});
var HeroBannerDescription = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "HeroBannerDescription",
    componentId: "sc-e949be28-8"
})(_templateObject8());
var HeroBannerCTAButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "HeroBannerCTAButton",
    componentId: "sc-e949be28-9"
})(_templateObject9());
var HeroBannerMainContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "HeroBannerMainContent",
    componentId: "sc-e949be28-10"
})(_templateObject10());

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/redux/actions/common.js
var common = __webpack_require__(31024);
// EXTERNAL MODULE: ./src/components/ReactSlickCarousel/index.js
var ReactSlickCarousel = __webpack_require__(42783);
// EXTERNAL MODULE: ./src/utils/bannerImageClick.js
var bannerImageClick = __webpack_require__(80841);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(86812);
// EXTERNAL MODULE: ./src/utils/renderStoreName.js
var renderStoreName = __webpack_require__(16802);
;// CONCATENATED MODULE: ./src/utils/returnImageBrightnessBoolean.js



/**
 * function used to conditionally check whether
 * banner image should be dimmed or not.
 * if it is not custom store return false for brightness(0.7)
 * otherwise check if either store name or store logo is being rendered.
 * if it is return false, otherwise return inverse of the first array value
 * @param {*} theme
 * @param {*} config
 * @return {*} array
 */ var returnImageBrightnessBoolean = function(theme, config) {
    var object = (0,renderStoreName/* renderStoreName */.u)(deviceWidth/* deviceWidth */.o, config);
    var uniqueValues = (0,_to_consumable_array/* default */.Z)(new Set(Object.values(object)));
    // if unique values length > 0, either store name or store logo is rendered so return false.
    if (!(theme === null || theme === void 0 ? void 0 : theme.custom_theme_flag) || uniqueValues.length > 1) {
        return false;
    } else {
        // return inverse of first array value
        return !uniqueValues[0];
    }
};

// EXTERNAL MODULE: ./src/components/DesignSystem/HeroBanner/hooks/useBannerImages.js + 1 modules
var useBannerImages = __webpack_require__(44206);
// EXTERNAL MODULE: ./src/components/DesignSystem/HeroBanner/common/BannerImageSliderNextPrevButtons.js
var BannerImageSliderNextPrevButtons = __webpack_require__(22398);
// EXTERNAL MODULE: ./src/components/DesignSystem/HeroBanner/utils.js
var utils = __webpack_require__(65710);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(26706);
;// CONCATENATED MODULE: ./src/components/DesignSystem/HeroBanner/HeroBanner7/index.js


















var HeroBanner7 = function(props) {
    var sliderRef = (0,react.useRef)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var heroBannerHeight = (0,es/* useSelector */.v9)(function(state) {
        return state.commonReducer.heightCalculation;
    }).heroBannerHeight;
    var ssrStoreData = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return state.storeReducer.store;
    });
    var ref = ssrStoreData || {}, storeInfo = ref.store_info, theme = ref.theme;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useBannerImages/* default */.Z)(), 1), bannerImages = ref1[0];
    var ref2 = (0,react.useState)({
        isHeightFetched: false,
        heightFetched: 0
    }), state = ref2[0], setState = ref2[1];
    (0,react.useEffect)(function() {
        dispatch((0,common/* getHeroBannerHeightCalculation */.A4)());
    }, []);
    (0,react.useEffect)(function() {
        if (!state.heightFetched) {
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    heightFetched: heroBannerHeight,
                    isHeightFetched: true
                });
            });
        }
    }, [
        heroBannerHeight
    ]);
    return storeInfo ? // <HeroBannerWrapperComponent7
    //   bannerFixedRatio={props.banner_fixed_ratio}
    //   heightCalculation={state.heightFetched}
    // >
    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "heroBannerWrapper ".concat(!(bannerImages === null || bannerImages === void 0 ? void 0 : bannerImages.length) ? "placeholder" : ""),
        children: [
            (bannerImages === null || bannerImages === void 0 ? void 0 : bannerImages.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerImageSliderNextPrevButtons/* default */.Z, {
                sliderRef: sliderRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactSlickCarousel/* Slider */.i, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                ref: function(slider) {
                    return sliderRef.current = slider;
                }
            }, utils/* sliderSettings */.K), {
                children: bannerImages === null || bannerImages === void 0 ? void 0 : bannerImages.map(function(img, idx) {
                    var ref, ref1, ref2;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBannerComponent, {
                        className: (img === null || img === void 0 ? void 0 : img.image_href) !== "" ? "pointer" : "",
                        bannerFixedRatio: theme === null || theme === void 0 ? void 0 : theme.banner_fixed_ratio,
                        heightCalculation: state.heightFetched,
                        onClick: function() {
                            return (0,bannerImageClick/* bannerImageClick */.X)(theme, img);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroBannerMainContent, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBannerImage, {
                                    height: idx === 0,
                                    // if banner index === 0 check for image brightness, otherwise return true
                                    imageBrightness: idx === 0 ? returnImageBrightnessBoolean(theme, props === null || props === void 0 ? void 0 : props.config) : true,
                                    children: (img === null || img === void 0 ? void 0 : img.image_url) && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        layout: "fill",
                                        objectFit: "cover",
                                        objectPosition: deviceWidth/* deviceWidth */.o < 767 ? "center top" : "center center",
                                        className: "next-banner-image",
                                        src: img === null || img === void 0 ? void 0 : img.image_url,
                                        priority: idx == 0
                                    })
                                }),
                                idx === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBannerInteractivePosition, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBannerInteractiveBody, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroBannerSection, {
                                            children: [
                                                ((ref = (0,renderStoreName/* renderStoreName */.u)(deviceWidth/* deviceWidth */.o, props === null || props === void 0 ? void 0 : props.config)) === null || ref === void 0 ? void 0 : ref.logo) && (storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.logo_image) && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBannerStoreImage, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.logo_image,
                                                        className: "next-store-image",
                                                        alt: "store logo",
                                                        height: "100%",
                                                        width: "100%",
                                                        objectFit: "cover",
                                                        objectPosition: "center center"
                                                    })
                                                }),
                                                ((ref1 = (0,renderStoreName/* renderStoreName */.u)(deviceWidth/* deviceWidth */.o, props === null || props === void 0 ? void 0 : props.config)) === null || ref1 === void 0 ? void 0 : ref1.storeName) && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBannerHeading, {
                                                    primaryColor: (theme === null || theme === void 0 ? void 0 : (ref2 = theme.colors) === null || ref2 === void 0 ? void 0 : ref2.primary_color) || "#ffffff",
                                                    children: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.name
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    }, img.id);
                })
            }))
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var HeroBanner_HeroBanner7 = (HeroBanner7);


/***/ }),

/***/ 22398:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var BannerImageSliderNextPrevButtons = function(param) {
    var sliderRef = param.sliderRef;
    /* slider prev button */ var handlePrevClick = function() {
        var ref;
        if (sliderRef === null || sliderRef === void 0 ? void 0 : (ref = sliderRef.current) === null || ref === void 0 ? void 0 : ref.slickPrev) {
            var ref1;
            sliderRef === null || sliderRef === void 0 ? void 0 : (ref1 = sliderRef.current) === null || ref1 === void 0 ? void 0 : ref1.slickPrev();
        }
    };
    /* slider next button */ var handleNextClick = function() {
        var ref;
        if (sliderRef === null || sliderRef === void 0 ? void 0 : (ref = sliderRef.current) === null || ref === void 0 ? void 0 : ref.slickNext) {
            var ref1;
            sliderRef === null || sliderRef === void 0 ? void 0 : (ref1 = sliderRef.current) === null || ref1 === void 0 ? void 0 : ref1.slickNext();
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                alt: "Left Button",
                src: "/assets/icons/arrowLeftIconCircleDark.png",
                className: "arrow-btns absolute left-1 img h2 mr2 pointer",
                onClick: handlePrevClick
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                alt: "Right Button",
                src: "/assets/icons/arrowRightIconCircleDark.png",
                className: "arrow-btns absolute right-1 img h2 mr2 pointer",
                onClick: handleNextClick
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BannerImageSliderNextPrevButtons);


/***/ }),

/***/ 44206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hooks_useBannerImages; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/redux/useSSRSelector.tsx
var useSSRSelector = __webpack_require__(2808);
;// CONCATENATED MODULE: ./src/hooks/useDeviceInfo.js


function useDeviceInfo() {
    var userAgent = (0,react.useContext)(useSSRSelector/* SSRSelectorContext */.v).userAgent;
    var isMobile = mobileCheck(userAgent);
    var isDesktop = !isMobile;
    return {
        isMobile: isMobile,
        isDesktop: isDesktop,
        isInvalidDevice: isMobile === null
    };
}
function mobileCheck(userAgent) {
    if (!userAgent) return null;
    var check = false;
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(userAgent.substr(0, 4))) check = true;
    return check;
}

// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(26706);
// EXTERNAL MODULE: ./src/utils/useIsComponentMounted.js
var useIsComponentMounted = __webpack_require__(71778);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(86812);
;// CONCATENATED MODULE: ./src/components/DesignSystem/HeroBanner/hooks/useBannerImages.js





var useBannerImages = function() {
    var isBannerListImageSame = function isBannerListImageSame(imgList) {
        var isBannerListSame = true;
        if (bannerImagesListClient === null || bannerImagesListClient === void 0 ? void 0 : bannerImagesListClient.length) {
            for(var i = 0; i < (bannerImagesListClient === null || bannerImagesListClient === void 0 ? void 0 : bannerImagesListClient.length); i++){
                var ref, ref1;
                if ((imgList === null || imgList === void 0 ? void 0 : (ref = imgList[i]) === null || ref === void 0 ? void 0 : ref.image_url) !== (bannerImagesListClient === null || bannerImagesListClient === void 0 ? void 0 : (ref1 = bannerImagesListClient[i]) === null || ref1 === void 0 ? void 0 : ref1.image_url)) {
                    isBannerListSame = false;
                    break;
                }
            }
            return isBannerListSame;
        }
    };
    var getFilteredBannerImages = function getFilteredBannerImages(isDesktop) {
        var ref, ref1, ref2, ref3;
        var sortedImages = ((ref2 = theme === null || theme === void 0 ? void 0 : (ref = theme.components) === null || ref === void 0 ? void 0 : (ref1 = ref.Body) === null || ref1 === void 0 ? void 0 : ref1.find(function(comp) {
            return (comp === null || comp === void 0 ? void 0 : comp.sub_type) === "HeroBanner";
        })) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.images) === null || ref3 === void 0 ? void 0 : ref3.sort(function(a, b) {
            return a.order - b.order;
        })) || [];
        if (isDesktop) {
            bannerImagesList = sortedImages.filter(function(el) {
                return el.is_desktop === true;
            });
        } else {
            bannerImagesList = sortedImages.filter(function(el) {
                return el.is_desktop === false;
            });
        }
        return bannerImagesList;
    };
    var ref = (0,react.useState)(false), isDocumentLoaded = ref[0], setDocumentLoaded = ref[1];
    var isDesktop = useDeviceInfo().isDesktop;
    var theme = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return state.storeReducer.store;
    }).theme;
    var isComponentMounted = (0,useIsComponentMounted/* default */.Z)();
    var bannerImagesList = [];
    // This will be false on Server & on Initial render itself
    if (!isComponentMounted) {
        bannerImagesList = getFilteredBannerImages(isDesktop);
    }
    var ref1 = (0,react.useState)(bannerImagesList || []), bannerImagesListClient = ref1[0], setBannerImagesListClient = ref1[1];
    (0,react.useEffect)(function() {
        window.addEventListener("load", function() {
            setTimeout(function() {
                return setDocumentLoaded(true);
            }, 2000);
        });
    }, []);
    (0,react.useEffect)(function() {
        var isDesktopBasedOnDeviceWidth = deviceWidth/* deviceWidth */.o > 767;
        var bannerImagesList = getFilteredBannerImages(isDesktopBasedOnDeviceWidth);
        if (!isBannerListImageSame(bannerImagesList)) {
            setBannerImagesListClient(bannerImagesList);
        }
    }, []);
    var bannerImages = !isDocumentLoaded ? bannerImagesListClient.slice(0, 1) : bannerImagesListClient;
    return [
        bannerImages
    ];
};
/* harmony default export */ var hooks_useBannerImages = (useBannerImages);


/***/ }),

/***/ 65710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ sliderSettings; }
/* harmony export */ });
/**
 * Slider base values
 */ var sliderSettings = {
    arrows: false,
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    pauseOnHover: false,
    autoplaySpeed: 3000,
    dotsClass: "herobanner_slider--icons"
};


/***/ }),

/***/ 80841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ bannerImageClick; }
/* harmony export */ });
/**
 * opening new window to show banner image if image_href exists
 * @param {*} theme
 * @param {*} img
 */ var bannerImageClick = function(theme, img) {
    if ((theme === null || theme === void 0 ? void 0 : theme.custom_theme_flag) && (img === null || img === void 0 ? void 0 : img.image_href)) {
        window.open("".concat(img.image_href), "_blank");
    }
};


/***/ }),

/***/ 16802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ renderStoreName; }
/* harmony export */ });
/**
 * * check for existence of logo and store name in config
 * @param {*} deviceWidth number
 * @param {*} config Object
 * @return {*} obj
 */ var renderStoreName = function() {
    var deviceWidth = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var returnObj = {
        logo: true,
        storeName: true
    };
    // only for custom website config exist.
    // So for non premium website return true for logo and name
    if (deviceWidth > 720 && config && Object.keys(config).length) {
        return {
            logo: config === null || config === void 0 ? void 0 : config.show_logo,
            storeName: config === null || config === void 0 ? void 0 : config.show_store_name
        };
    }
    return returnObj;
};


/***/ }),

/***/ 71778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/*
  Returns isComponentMounted
  isComponentMounted -> true / Component is Successfully mounted
*/ function useIsComponentMounted() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isComponentMounted = ref[0], setIsComponentMounted = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setIsComponentMounted(true);
    }, []);
    return isComponentMounted;
}
/* harmony default export */ __webpack_exports__["Z"] = (useIsComponentMounted);


/***/ })

}]);